var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 7.95H3.32539L7.57539 3.625C7.80039 3.4 7.80039 3.05 7.57539 2.825C7.35039 2.6 7.00039 2.6 6.77539 2.825L1.60039 8.075C1.37539 8.3 1.37539 8.65 1.60039 8.875L6.77539 14.125C6.87539 14.225 7.02539 14.3 7.17539 14.3C7.32539 14.3 7.45039 14.25 7.57539 14.15C7.80039 13.925 7.80039 13.575 7.57539 13.35L3.35039 9.075H14.0004C14.3004 9.075 14.5504 8.825 14.5504 8.525C14.5504 8.2 14.3004 7.95 14.0004 7.95Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg41);
export default __webpack_public_path__ + "static/media/svg41.e38c8227118aa92a84ab42725fb55d97.svg";
export { ForwardRef as ReactComponent };